import { createFileRoute } from "@tanstack/react-router"

import BlogDetailPage from "@/features/static/components/blogs/id"

export const Route = createFileRoute("/_screen/blog/$id")({
  component: BlogDetail
})

function BlogDetail() {
  const { id } = Route.useParams()
  return <BlogDetailPage id={id} />
}
